module.exports = __webpack_public_path__ + "img/MAC323_R.17aa892a.png";